export default [
  { id: 1, key: '0', value: '', label: '∅' },
  { id: 2, key: 'b', value: 'b', label: 'b' },
  { id: 3, key: 'c', value: 'c', label: 'c' },
  { id: 4, key: 'hj', value: 'ç', label: 'ç' },
  { id: 5, key: 'd', value: 'd', label: 'd' },
  { id: 6, key: 'dh', value: 'ð', label: 'ð' },
  { id: 7, key: 'f', value: 'f', label: 'f' },
  { id: 8, key: 'g', value: 'g', label: 'g' },
  { id: 9, key: 'h', value: 'h', label: 'h' },
  { id: 10, key: 'j', value: 'j', label: 'j' },
  { id: 11, key: 'gj', value: 'ɟ', label: 'ɟ' },
  { id: 12, key: 'k', value: 'k', label: 'k' },
  { id: 13, key: 'm', value: 'm', label: 'm' },
  { id: 14, key: 'n', value: 'n', label: 'n' },
  { id: 15, key: 'ɲ', value: 'ɲ', label: 'ɲ' },
  { id: 16, key: 'p', value: 'p', label: 'p' },
  { id: 17, key: 'r', value: 'r', label: 'r' },
  { id: 18, key: 's', value: 's', label: 's' },
  { id: 19, key: 'ʃ', value: 'ʃ', label: 'ʃ' },
  { id: 20, key: 't', value: 't', label: 't' },
  { id: 21, key: 'ts', value: 't͡s', label: 't͡s' },
  { id: 22, key: 'tsh', value: 't͡ʃ', label: 't͡ʃ' },
  { id: 23, key: 'v', value: 'v', label: 'v' },
  { id: 24, key: 'w', value: 'w', label: 'w' },
  { id: 25, key: 'z', value: 'z', label: 'z' },
  { id: 26, key: 'zh', value: 'ʒ', label: 'ʒ' },
  { id: 27, key: 'th', value: 'θ', label: 'θ' },
  { id: 28, key: 'bd', value: 'bd', label: 'bd' },
  { id: 29, key: 'bdh', value: 'bð', label: 'bð' },
  { id: 30, key: 'bn', value: 'bn', label: 'bn' },
  { id: 31, key: 'bs', value: 'bs', label: 'bs' },
  { id: 32, key: 'br', value: 'br', label: 'br' },
  { id: 33, key: 'bz', value: 'bz', label: 'bz' },
  { id: 34, key: 'bth', value: 'bθ', label: 'bθ' },
  { id: 35, key: 'hjs', value: 'çs', label: 'çs' },
  { id: 36, key: 'hjt', value: 'çt', label: 'çt' },
  { id: 37, key: 'dn', value: 'dn', label: 'dn' },
  { id: 38, key: 'dr', value: 'dr', label: 'dr' },
  { id: 39, key: 'dhr', value: 'ðr', label: 'ðr' },
  { id: 40, key: 'fdh', value: 'fð', label: 'fð' },
  { id: 41, key: 'fn', value: 'fn', label: 'fn' },
  { id: 42, key: 'fr', value: 'fr', label: 'fr' },
  { id: 43, key: 'fs', value: 'fs', label: 'fs' },
  { id: 44, key: 'fsh', value: 'fʃ', label: 'fʃ' },
  { id: 45, key: 'ft', value: 'ft', label: 'ft' },
  { id: 46, key: 'fts', value: 'ft͡s', label: 'ft͡s' },
  { id: 47, key: 'ftsh', value: 'ft͡ʃ', label: 'ft͡ʃ' },
  { id: 48, key: 'fth', value: 'fθ', label: 'fθ' },
  { id: 49, key: 'gd', value: 'gd', label: 'gd' },
  { id: 50, key: 'gdh', value: 'gð', label: 'gð' },
  { id: 51, key: 'gh', value: 'gh', label: 'gh' },
  { id: 52, key: 'gn', value: 'gn', label: 'gn' },
  { id: 53, key: 'gs', value: 'gs', label: 'gs' },
  { id: 54, key: 'gsh', value: 'gʃ', label: 'gʃ' },
  { id: 55, key: 'gr', value: 'gr', label: 'gr' },
  { id: 56, key: 'gz', value: 'gz', label: 'gz' },
  { id: 57, key: 'gth', value: 'gθ', label: 'gθ' },
  { id: 58, key: 'kd', value: 'kd', label: 'kd' },
  { id: 59, key: 'kf', value: 'kf', label: 'kf' },
  { id: 60, key: 'khj', value: 'kç', label: 'kç' },
  { id: 61, key: 'kn', value: 'kn', label: 'kn' },
  { id: 62, key: 'kr', value: 'kr', label: 'kr' },
  { id: 63, key: 'ks', value: 'ks', label: 'ks' },
  { id: 64, key: 'ksh', value: 'kʃ', label: 'kʃ' },
  { id: 65, key: 'kt', value: 'kt', label: 'kt' },
  { id: 66, key: 'kts', value: 'kt͡s', label: 'kt͡s' },
  { id: 67, key: 'ktsh', value: 'kt͡ʃ', label: 'kt͡ʃ' },
  { id: 68, key: 'kz', value: 'kz', label: 'kz' },
  { id: 69, key: 'kzh', value: 'kʒ', label: 'kʒ' },
  { id: 70, key: 'kth', value: 'kθ', label: 'kθ' },
  { id: 71, key: 'mb', value: 'mb', label: 'mb' },
  { id: 72, key: 'md', value: 'md', label: 'md' },
  { id: 73, key: 'mdh', value: 'mð', label: 'mð' },
  { id: 74, key: 'mk', value: 'mk', label: 'mk' },
  { id: 75, key: 'mn', value: 'mn', label: 'mn' },
  { id: 76, key: 'mp', value: 'mp', label: 'mp' },
  { id: 77, key: 'mr', value: 'mr', label: 'mr' },
  { id: 78, key: 'ms', value: 'ms', label: 'ms' },
  { id: 79, key: 'msh', value: 'mʃ', label: 'mʃ' },
  { id: 80, key: 'mt', value: 'mt', label: 'mt' },
  { id: 81, key: 'mts', value: 'mt͡s', label: 'mt͡s' },
  { id: 82, key: 'mtsh', value: 'mt͡ʃ', label: 'mt͡ʃ' },
  { id: 83, key: 'mz', value: 'mz', label: 'mz' },
  { id: 84, key: 'mth', value: 'mθ', label: 'mθ' },
  { id: 85, key: 'nd', value: 'nd', label: 'nd' },
  { id: 86, key: 'ndh', value: 'nð', label: 'nð' },
  { id: 87, key: 'nf', value: 'nf', label: 'nf' },
  { id: 88, key: 'ng', value: 'ng', label: 'ng' },
  { id: 89, key: 'nk', value: 'nk', label: 'nk' },
  { id: 90, key: 'nr', value: 'nr', label: 'nr' },
  { id: 91, key: 'ns', value: 'ns', label: 'ns' },
  { id: 92, key: 'nsh', value: 'nʃ', label: 'nʃ' },
  { id: 93, key: 'nt', value: 'nt', label: 'nt' },
  { id: 94, key: 'nts', value: 'nt͡s', label: 'nt͡s' },
  { id: 95, key: 'ntsh', value: 'nt͡ʃ', label: 'nt͡ʃ' },
  { id: 96, key: 'nv', value: 'nv', label: 'nv' },
  { id: 97, key: 'nz', value: 'nz', label: 'nz' },
  { id: 98, key: 'nzh', value: 'nʒ', label: 'nʒ' },
  { id: 99, key: 'nth', value: 'nθ', label: 'nθ' },
  { id: 100, key: 'pdh', value: 'pð', label: 'pð' },
  { id: 101, key: 'pf', value: 'pf', label: 'pf' },
  { id: 102, key: 'pn', value: 'pn', label: 'pn' },
  { id: 103, key: 'pr', value: 'pr', label: 'pr' },
  { id: 104, key: 'ps', value: 'ps', label: 'ps' },
  { id: 105, key: 'pt', value: 'pt', label: 'pt' },
  { id: 106, key: 'pts', value: 'pt͡s', label: 'pt͡s' },
  { id: 107, key: 'ptsh', value: 'pt͡ʃ', label: 'pt͡ʃ' },
  { id: 108, key: 'pz', value: 'pz', label: 'pz' },
  { id: 109, key: 'pth', value: 'pθ', label: 'pθ' },
  { id: 110, key: 'rb', value: 'rb', label: 'rb' },
  { id: 111, key: 'rd', value: 'rd', label: 'rd' },
  { id: 112, key: 'rdh', value: 'rð', label: 'rð' },
  { id: 113, key: 'rf', value: 'rf', label: 'rf' },
  { id: 114, key: 'rg', value: 'rg', label: 'rg' },
  { id: 115, key: 'rk', value: 'rk', label: 'rk' },
  { id: 116, key: 'rm', value: 'rm', label: 'rm' },
  { id: 117, key: 'rn', value: 'rn', label: 'rn' },
  { id: 118, key: 'rp', value: 'rp', label: 'rp' },
  { id: 119, key: 'rs', value: 'rs', label: 'rs' },
  { id: 120, key: 'rʃ', value: 'rʃ', label: 'rʃ' },
  { id: 121, key: 'rt', value: 'rt', label: 'rt' },
  { id: 122, key: 'rts', value: 'rt͡s', label: 'rt͡s' },
  { id: 123, key: 'rtsh', value: 'rt͡ʃ', label: 'rt͡ʃ' },
  { id: 124, key: 'rv', value: 'rv', label: 'rv' },
  { id: 125, key: 'rz', value: 'rz', label: 'rz' },
  { id: 126, key: 'rzh', value: 'rʒ', label: 'rʒ' },
  { id: 127, key: 'sd', value: 'sd', label: 'sd' },
  { id: 128, key: 'sdh', value: 'sð', label: 'sð' },
  { id: 129, key: 'sk', value: 'sk', label: 'sk' },
  { id: 130, key: 'sn', value: 'sn', label: 'sn' },
  { id: 131, key: 'sm', value: 'sm', label: 'sm' },
  { id: 132, key: 'sp', value: 'sp', label: 'sp' },
  { id: 133, key: 'sr', value: 'sr', label: 'sr' },
  { id: 134, key: 'st', value: 'st', label: 'st' },
  { id: 135, key: 'sts', value: 'st͡s', label: 'st͡s' },
  { id: 136, key: 'stsh', value: 'st͡ʃ', label: 'st͡ʃ' },
  { id: 137, key: 'sth', value: 'sθ', label: 'sθ' },
  { id: 138, key: 'shk', value: 'ʃk', label: 'ʃk' },
  { id: 139, key: 'shn', value: 'ʃn', label: 'ʃn' },
  { id: 140, key: 'shr', value: 'ʃr', label: 'ʃr' },
  { id: 141, key: 'sht', value: 'ʃt', label: 'ʃt' },
  { id: 142, key: 'shts', value: 'ʃt͡s', label: 'ʃt͡s' },
  { id: 143, key: 'shtsh', value: 'ʃt͡ʃ', label: 'ʃt͡ʃ' },
  { id: 144, key: 'tn', value: 'tn', label: 'tn' },
  { id: 145, key: 'tr', value: 'tr', label: 'tr' },
  { id: 146, key: 'tsn', value: 't͡sn', label: 't͡sn' },
  { id: 147, key: 'tsk', value: 't͡sk', label: 't͡sk' },
  { id: 148, key: 'tst', value: 't͡st', label: 't͡st' },
  { id: 149, key: 'tshk', value: 't͡ʃk', label: 't͡ʃk' },
  { id: 150, key: 'tshn', value: 't͡ʃn', label: 't͡ʃn' },
  { id: 151, key: 'tsht', value: 't͡ʃt', label: 't͡ʃt' },
  { id: 152, key: 'vd', value: 'vd', label: 'vd' },
  { id: 153, key: 'vð', value: 'vð', label: 'vð' },
  { id: 154, key: 'vf', value: 'vf', label: 'vf' },
  { id: 155, key: 'vn', value: 'vn', label: 'vn' },
  { id: 156, key: 'vr', value: 'vr', label: 'vr' },
  { id: 157, key: 'vs', value: 'vs', label: 'vs' },
  { id: 158, key: 'vz', value: 'vz', label: 'vz' },
  { id: 159, key: 'vth', value: 'vθ', label: 'vθ' },
  { id: 160, key: 'zm', value: 'zm', label: 'zm' },
  { id: 161, key: 'zn', value: 'zn', label: 'zn' },
  { id: 162, key: 'zr', value: 'zr', label: 'zr' },
  { id: 163, key: 'zd', value: 'zd', label: 'zd' },
  { id: 164, key: 'zdh', value: 'zð', label: 'zð' },
  { id: 165, key: 'zth', value: 'zθ', label: 'zθ' },
  { id: 166, key: 'zhd', value: 'ʒd', label: 'ʒd' },
  { id: 167, key: 'zhn', value: 'ʒn', label: 'ʒn' },
  { id: 168, key: 'thn', value: 'θn', label: 'θn' },
  { id: 169, key: 'ths', value: 'θs', label: 'θs' },
  { id: 170, key: 'thr', value: 'θr', label: 'θr' },
  { id: 171, key: 'thz', value: 'θz', label: 'θz' },
  { id: 172, key: 'bddh', value: 'bdð', label: 'bdð' },
  { id: 173, key: 'bdth', value: 'bdθ', label: 'bdθ' },
  { id: 174, key: 'brdh', value: 'brð', label: 'brð' },
  { id: 175, key: 'brf', value: 'brf', label: 'brf' },
  { id: 176, key: 'brg', value: 'brg', label: 'brg' },
  { id: 177, key: 'brk', value: 'brk', label: 'brk' },
  { id: 178, key: 'brm', value: 'brm', label: 'brm' },
  { id: 179, key: 'brs', value: 'brs', label: 'brs' },
  { id: 180, key: 'brsh', value: 'brʃ', label: 'brʃ' },
  { id: 181, key: 'brt', value: 'brt', label: 'brt' },
  { id: 182, key: 'brts', value: 'brt͡s', label: 'brt͡s' },
  { id: 183, key: 'brtsh', value: 'brt͡ʃ', label: 'brt͡ʃ' },
  { id: 184, key: 'brz', value: 'brz', label: 'brz' },
  { id: 185, key: 'brzh', value: 'brʒ', label: 'brʒ' },
  { id: 186, key: 'brth', value: 'brθ', label: 'brθ' },
  { id: 187, key: 'drdh', value: 'drð', label: 'drð' },
  { id: 188, key: 'drf', value: 'drf', label: 'drf' },
  { id: 189, key: 'drg', value: 'drg', label: 'drg' },
  { id: 190, key: 'drk', value: 'drk', label: 'drk' },
  { id: 191, key: 'drm', value: 'drm', label: 'drm' },
  { id: 192, key: 'drs', value: 'drs', label: 'drs' },
  { id: 193, key: 'drsh', value: 'drʃ', label: 'drʃ' },
  { id: 194, key: 'drtsh', value: 'drt͡ʃ', label: 'drt͡ʃ' },
  { id: 195, key: 'drv', value: 'drv', label: 'drv' },
  { id: 196, key: 'drz', value: 'drz', label: 'drz' },
  { id: 197, key: 'drzh', value: 'drʒ', label: 'drʒ' },
  { id: 198, key: 'drth', value: 'drθ', label: 'drθ' },
  { id: 199, key: 'dhrs', value: 'ðrs', label: 'ðrs' },
  { id: 200, key: 'fsk', value: 'fsk', label: 'fsk' },
  { id: 201, key: 'gdr', value: 'gdr', label: 'gdr' },
  { id: 202, key: 'gdhr', value: 'gðr', label: 'gðr' },
  { id: 203, key: 'gfs', value: 'gfs', label: 'gfs' },
  { id: 204, key: 'gsk', value: 'gsk', label: 'gsk' },
  { id: 205, key: 'gst', value: 'gst', label: 'gst' },
  { id: 206, key: 'gsts', value: 'gst͡s', label: 'gst͡s' },
  { id: 207, key: 'gsr', value: 'gsr', label: 'gsr' },
  { id: 208, key: 'grb', value: 'grb', label: 'grb' },
  { id: 209, key: 'grd', value: 'grd', label: 'grd' },
  { id: 210, key: 'grdh', value: 'grð', label: 'grð' },
  { id: 211, key: 'grf', value: 'grf', label: 'grf' },
  { id: 212, key: 'grm', value: 'grm', label: 'grm' },
  { id: 213, key: 'grp', value: 'grp', label: 'grp' },
  { id: 214, key: 'grs', value: 'grs', label: 'grs' },
  { id: 215, key: 'grsh', value: 'grʃ', label: 'grʃ' },
  { id: 216, key: 'grt', value: 'grt', label: 'grt' },
  { id: 217, key: 'grts', value: 'grt͡s', label: 'grt͡s' },
  { id: 218, key: 'grtsh', value: 'grt͡ʃ', label: 'grt͡ʃ' },
  { id: 219, key: 'grv', value: 'grv', label: 'grv' },
  { id: 220, key: 'grz', value: 'grz', label: 'grz' },
  { id: 221, key: 'grzh', value: 'grʒ', label: 'grʒ' },
  { id: 222, key: 'grth', value: 'grθ', label: 'grθ' },
  { id: 223, key: 'gvr', value: 'gvr', label: 'gvr' },
  { id: 224, key: 'gvz', value: 'gvz', label: 'gvz' },
  { id: 225, key: 'gvth', value: 'gvθ', label: 'gvθ' },
  { id: 226, key: 'gzr', value: 'gzr', label: 'gzr' },
  { id: 227, key: 'gthr', value: 'gθr', label: 'gθr' },
  { id: 228, key: 'kdr', value: 'kdr', label: 'kdr' },
  { id: 229, key: 'kdth', value: 'kdθ', label: 'kdθ' },
  { id: 230, key: 'kdhr', value: 'kðr', label: 'kðr' },
  { id: 231, key: 'kfs', value: 'kfs', label: 'kfs' },
  { id: 232, key: 'krb', value: 'krb', label: 'krb' },
  { id: 233, key: 'krd', value: 'krd', label: 'krd' },
  { id: 234, key: 'krdh', value: 'krð', label: 'krð' },
  { id: 235, key: 'krm', value: 'krm', label: 'krm' },
  { id: 236, key: 'krp', value: 'krp', label: 'krp' },
  { id: 237, key: 'krs', value: 'krs', label: 'krs' },
  { id: 238, key: 'krsh', value: 'krʃ', label: 'krʃ' },
  { id: 239, key: 'krt', value: 'krt', label: 'krt' },
  { id: 240, key: 'krts', value: 'krt͡s', label: 'krt͡s' },
  { id: 241, key: 'krtsh', value: 'krt͡ʃ', label: 'krt͡ʃ' },
  { id: 242, key: 'krzh', value: 'krʒ', label: 'krʒ' },
  { id: 243, key: 'krth', value: 'krθ', label: 'krθ' },
  { id: 244, key: 'ksr', value: 'ksr', label: 'ksr' },
  { id: 245, key: 'kst', value: 'kst', label: 'kst' },
  { id: 246, key: 'ksth', value: 'ksθ', label: 'ksθ' },
  { id: 247, key: 'kshr', value: 'kʃr', label: 'kʃr' },
  { id: 248, key: 'ksht', value: 'kʃt', label: 'kʃt' },
  { id: 249, key: 'ktr', value: 'ktr', label: 'ktr' },
  { id: 250, key: 'ktsr', value: 'kt͡sr', label: 'kt͡sr' },
  { id: 251, key: 'ktshr', value: 'kt͡ʃr', label: 'kt͡ʃr' },
  { id: 252, key: 'kzr', value: 'kzr', label: 'kzr' },
  { id: 253, key: 'kthr', value: 'kθr', label: 'kθr' },
  { id: 254, key: 'mbd', value: 'mbd', label: 'mbd' },
  { id: 255, key: 'mbdh', value: 'mbð', label: 'mbð' },
  { id: 256, key: 'mbs', value: 'mbs', label: 'mbs' },
  { id: 257, key: 'mbr', value: 'mbr', label: 'mbr' },
  { id: 258, key: 'mbz', value: 'mbz', label: 'mbz' },
  { id: 259, key: 'mbth', value: 'mbθ', label: 'mbθ' },
  { id: 260, key: 'mdr', value: 'mdr', label: 'mdr' },
  { id: 261, key: 'mdhr', value: 'mðr', label: 'mðr' },
  { id: 262, key: 'mkr', value: 'mkr', label: 'mkr' },
  { id: 263, key: 'mks', value: 'mks', label: 'mks' },
  { id: 264, key: 'mps', value: 'mps', label: 'mps' },
  { id: 265, key: 'mrd', value: 'mrd', label: 'mrd' },
  { id: 266, key: 'mrdh', value: 'mrð', label: 'mrð' },
  { id: 267, key: 'mrf', value: 'mrf', label: 'mrf' },
  { id: 268, key: 'mrs', value: 'mrs', label: 'mrs' },
  { id: 269, key: 'mrsh', value: 'mrʃ', label: 'mrʃ' },
  { id: 270, key: 'mrt', value: 'mrt', label: 'mrt' },
  { id: 271, key: 'mrv', value: 'mrv', label: 'mrv' },
  { id: 272, key: 'mrz', value: 'mrz', label: 'mrz' },
  { id: 273, key: 'mrzh', value: 'mrʒ', label: 'mrʒ' },
  { id: 274, key: 'mrth', value: 'mrθ', label: 'mrθ' },
  { id: 275, key: 'msk', value: 'msk', label: 'msk' },
  { id: 276, key: 'mst', value: 'mst', label: 'mst' },
  { id: 277, key: 'msts', value: 'mst͡s', label: 'mst͡s' },
  { id: 278, key: 'mzr', value: 'mzr', label: 'mzr' },
  { id: 279, key: 'mthr', value: 'mθr', label: 'mθr' },
  { id: 280, key: 'ndr', value: 'ndr', label: 'ndr' },
  { id: 281, key: 'ndhr', value: 'nðr', label: 'nðr' },
  { id: 282, key: 'nfdh', value: 'nfð', label: 'nfð' },
  { id: 283, key: 'nfr', value: 'nfr', label: 'nfr' },
  { id: 284, key: 'nfs', value: 'nfs', label: 'nfs' },
  { id: 285, key: 'nfsh', value: 'nfʃ', label: 'nfʃ' },
  { id: 286, key: 'nft', value: 'nft', label: 'nft' },
  { id: 287, key: 'nfts', value: 'nft͡s', label: 'nft͡s' },
  { id: 288, key: 'nftsh', value: 'nft͡ʃ', label: 'nft͡ʃ' },
  { id: 289, key: 'nfz', value: 'nfz', label: 'nfz' },
  { id: 290, key: 'nfth', value: 'nfθ', label: 'nfθ' },
  { id: 291, key: 'ngd', value: 'ngd', label: 'ngd' },
  { id: 292, key: 'ngdh', value: 'ngð', label: 'ngð' },
  { id: 293, key: 'ngf', value: 'ngf', label: 'ngf' },
  { id: 294, key: 'ngr', value: 'ngr', label: 'ngr' },
  { id: 295, key: 'ngs', value: 'ngs', label: 'ngs' },
  { id: 296, key: 'ngsh', value: 'ngʃ', label: 'ngʃ' },
  { id: 297, key: 'ngv', value: 'ngv', label: 'ngv' },
  { id: 298, key: 'ngz', value: 'ngz', label: 'ngz' },
  { id: 299, key: 'ngzh', value: 'ngʒ', label: 'ngʒ' },
  { id: 300, key: 'ngth', value: 'ngθ', label: 'ngθ' },
  { id: 301, key: 'nkf', value: 'nkf', label: 'nkf' },
  { id: 302, key: 'nkr', value: 'nkr', label: 'nkr' },
  { id: 303, key: 'nks', value: 'nks', label: 'nks' },
  { id: 304, key: 'nksh', value: 'nkʃ', label: 'nkʃ' },
  { id: 305, key: 'nkts', value: 'nkt͡s', label: 'nkt͡s' },
  { id: 306, key: 'nktsh', value: 'nkt͡ʃ', label: 'nkt͡ʃ' },
  { id: 307, key: 'nkth', value: 'nkθ', label: 'nkθ' },
  { id: 308, key: 'nrf', value: 'nrf', label: 'nrf' },
  { id: 309, key: 'nrk', value: 'nrk', label: 'nrk' },
  { id: 310, key: 'nrs', value: 'nrs', label: 'nrs' },
  { id: 311, key: 'nrsh', value: 'nrʃ', label: 'nrʃ' },
  { id: 312, key: 'nrv', value: 'nrv', label: 'nrv' },
  { id: 313, key: 'nrz', value: 'nrz', label: 'nrz' },
  { id: 314, key: 'nrzh', value: 'nrʒ', label: 'nrʒ' },
  { id: 315, key: 'nrth', value: 'nrθ', label: 'nrθ' },
  { id: 316, key: 'nsd', value: 'nsd', label: 'nsd' },
  { id: 317, key: 'nsdh', value: 'nsð', label: 'nsð' },
  { id: 318, key: 'nsk', value: 'nsk', label: 'nsk' },
  { id: 319, key: 'nsr', value: 'nsr', label: 'nsr' },
  { id: 320, key: 'nst', value: 'nst', label: 'nst' },
  { id: 321, key: 'nsth', value: 'nsθ', label: 'nsθ' },
  { id: 322, key: 'nsht', value: 'nʃt', label: 'nʃt' },
  { id: 323, key: 'ntr', value: 'ntr', label: 'ntr' },
  { id: 324, key: 'ntst', value: 'nt͡st', label: 'nt͡st' },
  { id: 325, key: 'ntsht', value: 'nt͡ʃt', label: 'nt͡ʃt' },
  { id: 326, key: 'nvd', value: 'nvd', label: 'nvd' },
  { id: 327, key: 'nvdh', value: 'nvð', label: 'nvð' },
  { id: 328, key: 'nvr', value: 'nvr', label: 'nvr' },
  { id: 329, key: 'nvs', value: 'nvs', label: 'nvs' },
  { id: 330, key: 'nvt', value: 'nvt', label: 'nvt' },
  { id: 331, key: 'nvz', value: 'nvz', label: 'nvz' },
  { id: 332, key: 'nvth', value: 'nvθ', label: 'nvθ' },
  { id: 333, key: 'nzr', value: 'nzr', label: 'nzr' },
  { id: 334, key: 'nthr', value: 'nθr', label: 'nθr' },
  { id: 335, key: 'pdhr', value: 'pðr', label: 'pðr' },
  { id: 336, key: 'pfs', value: 'pfs', label: 'pfs' },
  { id: 337, key: 'prd', value: 'prd', label: 'prd' },
  { id: 338, key: 'prdh', value: 'prð', label: 'prð' },
  { id: 339, key: 'prf', value: 'prf', label: 'prf' },
  { id: 340, key: 'prg', value: 'prg', label: 'prg' },
  { id: 341, key: 'prk', value: 'prk', label: 'prk' },
  { id: 342, key: 'prm', value: 'prm', label: 'prm' },
  { id: 343, key: 'prn', value: 'prn', label: 'prn' },
  { id: 344, key: 'prs', value: 'prs', label: 'prs' },
  { id: 345, key: 'prsh', value: 'prʃ', label: 'prʃ' },
  { id: 346, key: 'prt', value: 'prt', label: 'prt' },
  { id: 347, key: 'prts', value: 'prt͡s', label: 'prt͡s' },
  { id: 348, key: 'prtsh', value: 'prt͡ʃ', label: 'prt͡ʃ' },
  { id: 349, key: 'pst', value: 'pst', label: 'pst' },
  { id: 350, key: 'psts', value: 'pst͡s', label: 'pst͡s' },
  { id: 351, key: 'pstsh', value: 'pst͡ʃ', label: 'pst͡ʃ' },
  { id: 353, key: 'psht', value: 'pʃt', label: 'pʃt' },
  { id: 354, key: 'ptr', value: 'ptr', label: 'ptr' },
  { id: 355, key: 'ptsr', value: 'pt͡sr', label: 'pt͡sr' },
  { id: 356, key: 'pzr', value: 'pzr', label: 'pzr' },
  { id: 357, key: 'pzth', value: 'pzθ', label: 'pzθ' },
  { id: 358, key: 'pthr', value: 'pθr', label: 'pθr' },
  { id: 359, key: 'rbd', value: 'rbd', label: 'rbd' },
  { id: 360, key: 'rbdh', value: 'rbð', label: 'rbð' },
  { id: 361, key: 'rbs', value: 'rbs', label: 'rbs' },
  { id: 362, key: 'rbz', value: 'rbz', label: 'rbz' },
  { id: 363, key: 'rbth', value: 'rbθ', label: 'rbθ' },
  { id: 364, key: 'rdth', value: 'rdθ', label: 'rdθ' },
  { id: 365, key: 'rdhr', value: 'rðr', label: 'rðr' },
  { id: 366, key: 'rfs', value: 'rfs', label: 'rfs' },
  { id: 367, key: 'rfsh', value: 'rfʃ', label: 'rfʃ' },
  { id: 368, key: 'rft', value: 'rft', label: 'rft' },
  { id: 369, key: 'rfts', value: 'rft͡s', label: 'rft͡s' },
  { id: 370, key: 'rfth', value: 'rfθ', label: 'rfθ' },
  { id: 371, key: 'rgdh', value: 'rgð', label: 'rgð' },
  { id: 372, key: 'rgm', value: 'rgm', label: 'rgm' },
  { id: 373, key: 'rgr', value: 'rgr', label: 'rgr' },
  { id: 374, key: 'rgs', value: 'rgs', label: 'rgs' },
  { id: 375, key: 'rgz', value: 'rgz', label: 'rgz' },
  { id: 376, key: 'rgth', value: 'rgθ', label: 'rgθ' },
  { id: 377, key: 'rkf', value: 'rkf', label: 'rkf' },
  { id: 378, key: 'rkm', value: 'rkm', label: 'rkm' },
  { id: 379, key: 'rkr', value: 'rkr', label: 'rkr' },
  { id: 380, key: 'rks', value: 'rks', label: 'rks' },
  { id: 381, key: 'rksh', value: 'rkʃ', label: 'rkʃ' },
  { id: 382, key: 'rkt', value: 'rkt', label: 'rkt' },
  { id: 383, key: 'rkts', value: 'rkt͡s', label: 'rkt͡s' },
  { id: 384, key: 'rkth', value: 'rkθ', label: 'rkθ' },
  { id: 385, key: 'rmdh', value: 'rmð', label: 'rmð' },
  { id: 386, key: 'rmf', value: 'rmf', label: 'rmf' },
  { id: 387, key: 'rmr', value: 'rmr', label: 'rmr' },
  { id: 388, key: 'rms', value: 'rms', label: 'rms' },
  { id: 389, key: 'rmz', value: 'rmz', label: 'rmz' },
  { id: 390, key: 'rmth', value: 'rmth', label: 'rmth' },
  { id: 391, key: 'rnd', value: 'rnd', label: 'rnd' },
  { id: 392, key: 'rndh', value: 'rnð', label: 'rnð' },
  { id: 393, key: 'rng', value: 'rng', label: 'rng' },
  { id: 394, key: 'rnz', value: 'rnz', label: 'rnz' },
  { id: 395, key: 'rnth', value: 'rnθ', label: 'rnθ' },
  { id: 396, key: 'rps', value: 'rps', label: 'rps' },
  { id: 397, key: 'rpsh', value: 'rpʃ', label: 'rpʃ' },
  { id: 398, key: 'rpt', value: 'rpt', label: 'rpt' },
  { id: 399, key: 'rpts', value: 'rpt͡s', label: 'rpt͡s' },
  { id: 400, key: 'rsk', value: 'rsk', label: 'rsk' },
  { id: 401, key: 'rsm', value: 'rsm', label: 'rsm' },
  { id: 402, key: 'rst', value: 'rst', label: 'rst' },
  { id: 403, key: 'rsts', value: 'rst͡s', label: 'rst͡s' },
  { id: 404, key: 'rsth', value: 'rsθ', label: 'rsθ' },
  { id: 405, key: 'rʃk', value: 'rʃk', label: 'rʃk' },
  { id: 406, key: 'rʃm', value: 'rʃm', label: 'rʃm' },
  { id: 407, key: 'rʃt', value: 'rʃt', label: 'rʃt' },
  { id: 408, key: 'rtk', value: 'rtk', label: 'rtk' },
  { id: 409, key: 'rtm', value: 'rtm', label: 'rtm' },
  { id: 410, key: 'rtr', value: 'rtr', label: 'rtr' },
  { id: 411, key: 'rtsr', value: 'rt͡sr', label: 'rt͡sr' },
  { id: 412, key: 'rvdh', value: 'rvð', label: 'rvð' },
  { id: 413, key: 'rvr', value: 'rvr', label: 'rvr' },
  { id: 414, key: 'rvz', value: 'rvz', label: 'rvz' },
  { id: 415, key: 'rvth', value: 'rvθ', label: 'rvθ' },
  { id: 416, key: 'rzr', value: 'rzr', label: 'rzr' },
  { id: 417, key: 'rzth', value: 'rzθ', label: 'rzθ' },
  { id: 418, key: 'sdr', value: 'sdr', label: 'sdr' },
  { id: 419, key: 'sdth', value: 'sdθ', label: 'sdθ' },
  { id: 420, key: 'sdhr', value: 'sðr', label: 'sðr' },
  { id: 421, key: 'skm', value: 'skm', label: 'skm' },
  { id: 422, key: 'skr', value: 'skr', label: 'skr' },
  { id: 423, key: 'sks', value: 'sks', label: 'sks' },
  { id: 424, key: 'skt', value: 'skt', label: 'skt' },
  { id: 425, key: 'skth', value: 'skθ', label: 'skθ' },
  { id: 426, key: 'smg', value: 'smg', label: 'smg' },
  { id: 427, key: 'smk', value: 'smk', label: 'smk' },
  { id: 428, key: 'smr', value: 'smr', label: 'smr' },
  { id: 429, key: 'smt', value: 'smt', label: 'smt' },
  { id: 430, key: 'smz', value: 'smz', label: 'smz' },
  { id: 431, key: 'smth', value: 'smθ', label: 'smθ' },
  { id: 432, key: 'spf', value: 'spf', label: 'spf' },
  { id: 433, key: 'spr', value: 'spr', label: 'spr' },
  { id: 434, key: 'sps', value: 'spt', label: 'sps' },
  { id: 435, key: 'spt', value: 'spt', label: 'spt' },
  { id: 436, key: 'spts', value: 'spt͡s', label: 'spt͡s' },
  { id: 437, key: 'spth', value: 'spθ', label: 'spθ' },
  { id: 438, key: 'srb', value: 'srb', label: 'srb' },
  { id: 439, key: 'srd', value: 'srd', label: 'srd' },
  { id: 440, key: 'srdh', value: 'srð', label: 'srð' },
  { id: 441, key: 'srf', value: 'srf', label: 'srf' },
  { id: 442, key: 'srg', value: 'srg', label: 'srg' },
  { id: 443, key: 'srk', value: 'srk', label: 'srk' },
  { id: 444, key: 'srm', value: 'srm', label: 'srm' },
  { id: 445, key: 'srn', value: 'srn', label: 'srn' },
  { id: 446, key: 'srp', value: 'srp', label: 'srp' },
  { id: 447, key: 'srs', value: 'srs', label: 'srs' },
  { id: 448, key: 'srsh', value: 'srʃ', label: 'srʃ' },
  { id: 449, key: 'srt', value: 'srt', label: 'srt' },
  { id: 450, key: 'srts', value: 'srt͡s', label: 'srt͡s' },
  { id: 451, key: 'srz', value: 'srz', label: 'srz' },
  { id: 452, key: 'srth', value: 'srθ', label: 'srθ' },
  { id: 453, key: 'stm', value: 'stm', label: 'stm' },
  { id: 454, key: 'str', value: 'str', label: 'str' },
  { id: 455, key: 'stsk', value: 'st͡sk', label: 'st͡sk' },
  { id: 456, key: 'stsr', value: 'st͡sr', label: 'st͡sr' },
  { id: 457, key: 'sthr', value: 'sθr', label: 'sθr' },
  { id: 458, key: 'trd', value: 'trd', label: 'trd' },
  { id: 459, key: 'trf', value: 'trf', label: 'trf' },
  { id: 460, key: 'trg', value: 'trg', label: 'trg' },
  { id: 461, key: 'trk', value: 'trk', label: 'trk' },
  { id: 462, key: 'trm', value: 'trm', label: 'trm' },
  { id: 463, key: 'trs', value: 'trs', label: 'trs' },
  { id: 464, key: 'trsh', value: 'trʃ', label: 'trʃ' },
  { id: 465, key: 'trv', value: 'trv', label: 'trv' },
  { id: 466, key: 'trz', value: 'trz', label: 'trz' },
  { id: 467, key: 'trzh', value: 'trʒ', label: 'trʒ' },
  { id: 468, key: 'trth', value: 'trθ', label: 'trθ' },
  { id: 469, key: 'tskr', value: 't͡skr', label: 't͡skr' },
  { id: 470, key: 'tstr', value: 't͡str', label: 't͡str' },
  { id: 471, key: 'tshkr', value: 't͡ʃkr', label: 't͡ʃkr' },
  { id: 472, key: 'tshtr', value: 't͡ʃt', label: 't͡ʃtr' },
  { id: 473, key: 'vdr', value: 'vdr', label: 'vdr' },
  { id: 474, key: 'vdth', value: 'vdθ', label: 'vdθ' },
  { id: 475, key: 'vðr', value: 'vðr', label: 'vðr' },
  { id: 476, key: 'vfs', value: 'vfs', label: 'vfs' },
  { id: 477, key: 'vfsh', value: 'vfʃ', label: 'vfʃ' },
  { id: 478, key: 'vft', value: 'vft', label: 'vft' },
  { id: 479, key: 'vfts', value: 'vft͡s', label: 'vft͡s' },
  { id: 480, key: 'vfth', value: 'vfθ', label: 'vfθ' },
  { id: 481, key: 'vrd', value: 'vrd', label: 'vrd' },
  { id: 482, key: 'vrdh', value: 'vrð', label: 'vrð' },
  { id: 483, key: 'vrf', value: 'vrf', label: 'vrf' },
  { id: 484, key: 'vrg', value: 'vrg', label: 'vrg' },
  { id: 485, key: 'vrk', value: 'vrk', label: 'vrk' },
  { id: 486, key: 'vrm', value: 'vrm', label: 'vrm' },
  { id: 487, key: 'vrn', value: 'vrn', label: 'vrn' },
  { id: 488, key: 'vrs', value: 'vrs', label: 'vrs' },
  { id: 489, key: 'vrsh', value: 'vrʃ', label: 'vrʃ' },
  { id: 490, key: 'vrt', value: 'vrt', label: 'vrt' },
  { id: 491, key: 'vrts', value: 'vrt͡s', label: 'vrt͡s' },
  { id: 492, key: 'vrz', value: 'vrz', label: 'vrz' },
  { id: 493, key: 'vrzh', value: 'vrʒ', label: 'vrʒ' },
  { id: 494, key: 'vrth', value: 'vrθ', label: 'vrθ' },
  { id: 495, key: 'vsf', value: 'vsf', label: 'vsf' },
  { id: 496, key: 'vsk', value: 'vsk', label: 'vsk' },
  { id: 497, key: 'vsm', value: 'vsm', label: 'vsm' },
  { id: 498, key: 'vsn', value: 'vsn', label: 'vsn' },
  { id: 499, key: 'vsp', value: 'vsp', label: 'vsp' },
  { id: 500, key: 'vsr', value: 'vsr', label: 'vsr' },
  { id: 501, key: 'vst', value: 'vst', label: 'vst' },
  { id: 502, key: 'vsts', value: 'vst͡s', label: 'vst͡s' },
  { id: 503, key: 'vsth', value: 'vsθ', label: 'vsθ' },
  { id: 504, key: 'vzf', value: 'vzf', label: 'vzf' },
  { id: 505, key: 'vzm', value: 'vzm', label: 'vzm' },
  { id: 506, key: 'vzr', value: 'vzr', label: 'vzr' },
  { id: 507, key: 'vzth', value: 'vzθ', label: 'vzθ' },
  { id: 508, key: 'vthr', value: 'vθr', label: 'vθr' },
  { id: 509, key: 'zrd', value: 'zrd', label: 'zrd' },
  { id: 510, key: 'zrf', value: 'zrf', label: 'zrf' },
  { id: 511, key: 'zrg', value: 'zrg', label: 'zrg' },
  { id: 512, key: 'zrm', value: 'zrm', label: 'zrm' },
  { id: 513, key: 'zrn', value: 'zrn', label: 'zrn' },
  { id: 514, key: 'zrs', value: 'zrs', label: 'zrs' },
  { id: 515, key: 'zrsh', value: 'zrʃ', label: 'zrʃ' },
  { id: 516, key: 'zrt', value: 'zrt', label: 'zrt' },
  { id: 517, key: 'zrv', value: 'zrv', label: 'zrv' },
  { id: 518, key: 'zdr', value: 'zdr', label: 'zdr' },
  { id: 519, key: 'zdth', value: 'zdθ', label: 'zdθ' },
  { id: 520, key: 'zrth', value: 'zrθ', label: 'zrθ' },
  { id: 521, key: 'thrb', value: 'θrb', label: 'θrb' },
  { id: 522, key: 'thrd', value: 'θrd', label: 'θrd' },
  { id: 523, key: 'thrf', value: 'θrf', label: 'θrf' },
  { id: 524, key: 'thrg', value: 'θrg', label: 'θrg' },
  { id: 525, key: 'thrk', value: 'θrk', label: 'θrk' },
  { id: 526, key: 'thrm', value: 'θrm', label: 'θrm' },
  { id: 527, key: 'thrn', value: 'θrn', label: 'θrn' },
  { id: 528, key: 'thrp', value: 'θrp', label: 'θrp' },
  { id: 529, key: 'thrs', value: 'θrs', label: 'θrs' },
  { id: 530, key: 'thrsh', value: 'θrʃ', label: 'θrʃ' },
  { id: 531, key: 'thrt', value: 'θrt', label: 'θrt' },
  { id: 532, key: 'thrts', value: 'θrt͡s', label: 'θrt͡s' },
  { id: 533, key: 'thrtsh', value: 'θrt͡ʃ', label: 'θrt͡ʃ' },
  { id: 534, key: 'thrv', value: 'θrv', label: 'θrv' },
  { id: 535, key: 'thrz', value: 'θrz', label: 'θrz' },
  { id: 536, key: 'thrzh', value: 'θrʒ', label: 'θrʒ' },
]
